import classes from "./product_section.module.css";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

const robots = [
  require("../../assets/images/robot 1.png"),
  require("../../assets/images/robot 2.png"),
  require("../../assets/images/robot 3.png"),
  require("../../assets/images/robot 4.png"),
  require("../../assets/images/robot 5.png"),
  require("../../assets/images/robot 6.png"),
  require("../../assets/images/robot 7.png"),
  require("../../assets/images/robot 8.png"),
  require("../../assets/images/robot 9.png"),
  require("../../assets/images/robot 10.png"),
  require("../../assets/images/robot 11.png"),
  require("../../assets/images/robot 12.png"),
];

const ProductSection = () => {
  const storedLang = localStorage.getItem("lang");
  let lng = storedLang ?? navigator.language;
  const { t, i18n } = useTranslation();

  useEffect(() => {
    i18n.changeLanguage(lng);
  }, [lng, i18n]);

  const [currentIndex, setIndex] = useState(0);

  const NextSlider = () => {
    if (currentIndex !== robots.length - 1) {
      setIndex((previewsIndex) => previewsIndex + 1);
    } else {
      setIndex(0);
    }
  };

  const PrevSlider = () => {
    if (currentIndex !== 0) {
      setIndex((previewsIndex) => previewsIndex - 1);
    } else {
      setIndex(robots.length - 1);
    }
  };

  const goToSlider = (index) => {
    setIndex(index);
  };

  return (
    <section className={classes["product-section"]} id="prototype">
      <div className={classes.container}>
        <h2 className={classes["heading-title"]}>{t("products.title")}</h2>
        <div className={classes.products}>
          <button className={classes.btn} onClick={PrevSlider}>
            <ion-icon
              class={classes["left-arrow"]}
              name="chevron-back-outline"
            ></ion-icon>
          </button>

          <div className={classes.product}>
            <p className={classes["product-name"]}>Minntes</p>
            <img
              className={classes.img}
              src={robots[currentIndex]}
              alt="minntes delivery robot"
            />
            <div className={classes.indicator}>
              {robots.map((robot, index) => {
                if (currentIndex === index) {
                  return (
                    <div
                      key={index}
                      className={`${classes["circle"]} ${classes["current-indicator"]}`}
                    ></div>
                  );
                }
                return (
                  <div
                    key={index}
                    className={classes.circle}
                    onClick={() => goToSlider(index)}
                  ></div>
                );
              })}
            </div>
          </div>
          <button className={classes.btn} onClick={NextSlider}>
            <ion-icon
              class={classes["right-arrow"]}
              name="chevron-forward-outline"
            ></ion-icon>
          </button>
        </div>
      </div>
    </section>
  );
};

export default ProductSection;
